import { createSelector } from '@ngrx/store';
import { State } from '..';

export const globalStateSelector = (state: State) => state.global;

export const environmentSelector = createSelector(globalStateSelector, (state) => state?.environment);

export const organisationsSelector = createSelector(globalStateSelector, (state) => state?.organisations);

export const organisationsLoadingSelector = createSelector(globalStateSelector, (state) => state?.organisations.loading);
